import { useState } from 'react';

const solutions = [
  {
    id: 'pac-air-air',
    icon: 'ri-temp-hot-line',
    color: 'orange',
    tag: 'Le plus populaire',
    title: 'Pompe à chaleur air/air',
    subtitle: 'Chaud en hiver, frais en été',
    saving: '70%',
    savingLabel: 'd\'économies sur le chauffage',
    description: 'La solution idéale pour chauffer et climatiser votre logement toute l\'année. Silencieuse, rapide à installer et très économique.',
    image: "https://public.readdy.ai/ai/img_res/c35e24ce88f4c1f122694ce1ec85a622.jpg",
    features: ['Réversible chaud/froid', 'Installation en 1 journée', 'Eligible aux aides de l\'État', 'Garantie 5 ans pièces & main d\'œuvre'],
    aide: 'Jusqu\'à 5 000 € d\'aides'
  },
  {
    id: 'pac-air-eau',
    icon: 'ri-drop-line',
    color: 'teal',
    tag: 'Remplace la chaudière',
    title: 'Pompe à chaleur air/eau',
    subtitle: 'Chauffage central + eau chaude',
    saving: '65%',
    savingLabel: 'de réduction sur vos factures',
    description: 'Remplacez définitivement votre vieille chaudière gaz ou fioul. Compatible avec vos radiateurs existants et vos planchers chauffants.',
    image: "https://readdy.ai/api/search-image?query=Modern%20air%20to%20water%20heat%20pump%20outdoor%20unit%20installed%20beside%20clean%20modern%20house%20exterior%20wall%2C%20green%20hedge%20background%2C%20white%20unit%2C%20bright%20daylight%2C%20residential%20garden%2C%20photorealistic%20warm%20tones&width=700&height=480&seq=pac-aireau-v2&orientation=landscape",
    features: ['Compatible radiateurs existants', 'Eau chaude sanitaire incluse', 'Plancher chauffant possible', 'Eligible MaPrimeRénov\''],
    aide: 'Jusqu\'à 10 000 € d\'aides'
  },
  {
    id: 'photovoltaique',
    icon: 'ri-sun-line',
    color: 'yellow',
    tag: 'Investissement rentable',
    title: 'Panneaux photovoltaïques',
    subtitle: 'Produisez votre propre électricité',
    saving: '100%',
    savingLabel: 'autoconsommation possible',
    description: 'Produisez et stockez votre propre électricité. Revenez au réseau le surplus, ou stockez-le dans des batteries pour une autonomie totale.',
    image: "https://readdy.ai/api/search-image?query=Beautiful%20high%20efficiency%20solar%20photovoltaic%20panels%20on%20modern%20residential%20house%20rooftop%2C%20bright%20sunny%20day%2C%20blue%20sky%2C%20suburban%20French%20neighborhood%2C%20warm%20afternoon%20light%2C%20professional%20real%20estate%20photography&width=700&height=480&seq=solar-pv-v2&orientation=landscape",
    features: ['Autoconsommation optimisée', 'Batteries de stockage disponibles', 'Revente du surplus EDF', '25 ans de garantie panneau'],
    aide: 'TVA réduite à 10 % — Prime autoconsommation'
  },
  {
    id: 'solaire-combine',
    icon: 'ri-contrast-2-line',
    color: 'green',
    tag: 'Solution complète',
    title: 'Système solaire combiné',
    subtitle: 'Électricité + eau chaude',
    saving: '80%',
    savingLabel: 'de la facture énergétique',
    description: 'Le combo gagnant : panneaux thermiques et photovoltaïques en une seule installation pour maximiser votre rentabilité.',
    image: "https://readdy.ai/api/search-image?query=Combined%20solar%20thermal%20and%20photovoltaic%20panel%20system%20on%20modern%20French%20residential%20rooftop%2C%20technician%20installing%20panels%2C%20warm%20sunlight%2C%20beautiful%20suburban%20home%2C%20blue%20sky%2C%20professional%20photography&width=700&height=480&seq=solaire-combine-v2&orientation=landscape",
    features: ['Double production d\'énergie', 'Rentabilité maximale', 'Installation coordonnée', 'Étude personnalisée offerte'],
    aide: 'Jusqu\'à 15 000 € d\'aides'
  },
  {
    id: 'isolation-combles',
    icon: 'ri-home-4-line',
    color: 'rose',
    tag: 'Perte de chaleur n°1',
    title: 'Isolation des combles',
    subtitle: 'Combles perdus & aménagés',
    saving: '30%',
    savingLabel: 'sur la facture de chauffage',
    description: 'Les combles représentent 30% des pertes de chaleur. Notre isolation haute performance stoppe les déperditions thermiques et améliore votre DPE immédiatement.',
    image: "https://readdy.ai/api/search-image?query=Professional%20thermal%20insulation%20installation%20in%20attic%20roof%20space%2C%20worker%20applying%20mineral%20wool%20insulation%20on%20ceiling%20beams%2C%20residential%20home%20energy%20renovation%2C%20warm%20light%2C%20clean%20professional%20work&width=700&height=480&seq=isolation-combles-v3&orientation=landscape",
    features: ['Combles perdus & aménagés', 'Matériaux écologiques disponibles', 'Amélioration DPE garantie', 'Eligible MaPrimeRénov\''],
    aide: 'Jusqu\'à 7 000 € d\'aides'
  },
  {
    id: 'isolation-soussol',
    icon: 'ri-building-line',
    color: 'slate',
    tag: 'Plancher froid',
    title: 'Isolation sous-sol',
    subtitle: 'Plancher bas & vide sanitaire',
    saving: '15%',
    savingLabel: 'de gain sur vos factures',
    description: 'L\'isolation du plancher bas (sous-sol, vide sanitaire) élimine les remontées de froid et améliore sensiblement le confort de votre logement en hiver.',
    image: "https://readdy.ai/api/search-image?query=Professional%20under%20floor%20insulation%20in%20residential%20basement%20crawl%20space%2C%20rigid%20foam%20insulation%20panels%20being%20installed%20on%20floor%2C%20energy%20efficient%20renovation%2C%20clean%20professional%20technique%2C%20warm%20tones&width=700&height=480&seq=isolation-sous-sol-v3&orientation=landscape",
    features: ['Vide sanitaire & sous-sol', 'Fin des remontées de froid', 'Matériaux durables', 'Certifié RGE'],
    aide: 'Jusqu\'à 5 000 € d\'aides'
  },
  {
    id: 'ite',
    icon: 'ri-layout-masonry-line',
    color: 'indigo',
    tag: 'Rénovation globale',
    title: 'Isolation extérieure (ITE)',
    subtitle: 'Bardage & enduit thermique',
    saving: '25%',
    savingLabel: 'de réduction facture énergie',
    description: 'L\'isolation thermique par l\'extérieur traite tous les ponts thermiques sans perte de surface habitable, tout en embellissant la façade de votre maison.',
    image: "https://readdy.ai/api/search-image?query=Workers%20installing%20exterior%20thermal%20insulation%20cladding%20panels%20on%20modern%20residential%20house%20facade%2C%20energy%20renovation%20construction%2C%20bright%20daylight%2C%20clean%20white%20and%20grey%20tones%2C%20professional%20renovation%20team&width=700&height=480&seq=ite-v3&orientation=landscape",
    features: ['Sans perte de surface habitable', 'Traitement des ponts thermiques', 'Ravalement de façade inclus', 'Aide jusqu\'à 15 000 €'],
    aide: 'Jusqu\'à 15 000 € d\'aides'
  }
];

const colorMap: Record<string, { bg: string; text: string; light: string; badge: string }> = {
  orange: { bg: 'bg-orange-500',  text: 'text-orange-500',  light: 'bg-orange-50',  badge: 'bg-orange-100 text-orange-700' },
  teal:   { bg: 'bg-teal-500',   text: 'text-teal-500',   light: 'bg-teal-50',   badge: 'bg-teal-100 text-teal-700' },
  yellow: { bg: 'bg-amber-500',  text: 'text-amber-500',  light: 'bg-amber-50',  badge: 'bg-amber-100 text-amber-700' },
  green:  { bg: 'bg-emerald-500', text: 'text-emerald-600', light: 'bg-emerald-50', badge: 'bg-emerald-100 text-emerald-700' },
  rose:   { bg: 'bg-rose-500',   text: 'text-rose-500',   light: 'bg-rose-50',   badge: 'bg-rose-100 text-rose-700' },
  slate:  { bg: 'bg-slate-600',  text: 'text-slate-600',  light: 'bg-slate-50',  badge: 'bg-slate-100 text-slate-700' },
  indigo: { bg: 'bg-indigo-500', text: 'text-indigo-600', light: 'bg-indigo-50', badge: 'bg-indigo-100 text-indigo-700' },
};

export default function SolutionsSection() {
  const [active, setActive] = useState(0);
  const sol = solutions[active];
  const c = colorMap[sol.color];

  return (
    <section id="solutions" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-orange-100 text-orange-600 text-sm font-bold px-4 py-1.5 rounded-full mb-4">Nos Solutions</span>
          <h2 className="text-4xl lg:text-5xl font-extrabold text-slate-900 mb-4">
            Économisez sur votre énergie<br />
            <span className="text-orange-500">dès cette année</span>
          </h2>
          <p className="text-lg text-slate-500 max-w-2xl mx-auto">
            Des solutions adaptées à chaque logement, avec les meilleures aides de l'État pour réduire votre investissement.
          </p>
        </div>

        {/* Tab selector */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {solutions.map((s, i) => (
            <button
              key={s.id}
              onClick={() => setActive(i)}
              className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap ${
                i === active
                  ? `${colorMap[s.color].bg} text-white shadow-md scale-105`
                  : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
              }`}
            >
              <i className={`${s.icon} text-base`}></i>
              {s.title}
            </button>
          ))}
        </div>

        {/* Active solution card */}
        <div className="grid lg:grid-cols-2 gap-10 items-center bg-slate-50 rounded-3xl overflow-hidden">
          {/* Image */}
          <div className="relative h-80 lg:h-full min-h-80">
            <img
              src={sol.image}
              alt={sol.title}
              className="w-full h-full object-cover object-top"
            />
            {/* Saving badge */}
            <div className={`absolute top-6 left-6 ${c.bg} text-white rounded-2xl px-4 py-3 text-center`}>
              <div className="text-3xl font-extrabold leading-none">{sol.saving}</div>
              <div className="text-xs font-medium opacity-90 mt-0.5">{sol.savingLabel}</div>
            </div>
            {/* Tag */}
            <div className="absolute bottom-6 left-6 bg-white/90 backdrop-blur-sm text-slate-700 text-xs font-bold px-3 py-1.5 rounded-full">
              {sol.tag}
            </div>
          </div>

          {/* Content */}
          <div className="p-8 lg:p-10">
            <div className={`inline-flex items-center gap-2 ${c.badge} text-sm font-semibold px-3 py-1 rounded-full mb-4`}>
              <i className={`${sol.icon}`}></i>
              {sol.subtitle}
            </div>
            <h3 className="text-3xl font-extrabold text-slate-900 mb-3">{sol.title}</h3>
            <p className="text-slate-600 mb-6 leading-relaxed">{sol.description}</p>

            <ul className="space-y-2.5 mb-6">
              {sol.features.map((f, i) => (
                <li key={i} className="flex items-center gap-3 text-slate-700">
                  <div className={`w-5 h-5 ${c.bg} rounded-full flex items-center justify-center flex-shrink-0`}>
                    <i className="ri-check-line text-white text-xs"></i>
                  </div>
                  {f}
                </li>
              ))}
            </ul>

            {/* Aide badge */}
            <div className={`${c.light} border border-current/10 rounded-xl px-4 py-3 flex items-center gap-3 mb-7`}>
              <i className={`ri-government-line ${c.text} text-xl`}></i>
              <div>
                <p className="text-xs text-slate-500 font-medium">Aide disponible</p>
                <p className={`font-bold ${c.text}`}>{sol.aide}</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="#contact"
                className={`${c.bg} hover:opacity-90 text-white font-bold px-7 py-3.5 rounded-full transition-all cursor-pointer whitespace-nowrap text-center`}
              >
                Demander un devis gratuit
              </a>
              <a
                href="tel:0189293323"
                className="border-2 border-slate-200 text-slate-700 hover:border-slate-400 font-semibold px-7 py-3.5 rounded-full transition-all cursor-pointer whitespace-nowrap text-center"
              >
                Nous appeler
              </a>
            </div>
          </div>
        </div>

        {/* Bottom stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
          {[
            { val: '70%', label: 'Économies moyenne sur le chauffage', icon: 'ri-fire-line', color: 'text-orange-500' },
            { val: '48h', label: 'Devis reçu, étude personnalisée', icon: 'ri-time-line', color: 'text-teal-500' },
            { val: '10k+', label: 'Foyers équipés en France', icon: 'ri-home-heart-line', color: 'text-emerald-500' },
            { val: '25 ans', label: 'Garantie sur les panneaux solaires', icon: 'ri-shield-check-line', color: 'text-amber-500' },
          ].map((s, i) => (
            <div key={i} className="bg-slate-50 rounded-2xl p-6 text-center">
              <div className={`text-3xl mb-1 ${s.color}`}><i className={s.icon}></i></div>
              <div className="text-2xl font-extrabold text-slate-900 mb-1">{s.val}</div>
              <div className="text-sm text-slate-500">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
